module.exports = __webpack_public_path__ + "img/طبیعی.24b5b665.png";